export const ButtonColor = '#0a7cff';

export const ButtonLanguage = 'es_LA';

export const startDisplay = ['hide'];
